import {Userrole} from "../../shared/interfaces/user";
import {Report} from "../../shared/interfaces/report";
import {Database} from "../../../../supabase/database.types";

export enum EscalationStatus {
  CREATED,
  ACCEPTED,
  IN_PROGRESS,
  COMPLETED
}

export function getEscalationStatus(status: number) {
  switch (status) {
    case EscalationStatus.CREATED:
      return 'Erstellt'
    case EscalationStatus.ACCEPTED:
      return 'Angenommen'
    case EscalationStatus.IN_PROGRESS:
      return 'In Arbeit'
    default:
      return 'Abgeschlossen'
  }
}

export interface Escalation {
  id: string,
  created_at: string,
  created_by: string | null,
  report: string | null,
  assigned_to_role: Userrole | string | null,
  assigned_to_user: string | null,
  status: EscalationStatus | number | null,
  message: string | null,
  processing_status_notification: string | null
}

export type UpdateEscalation = Database["public"]["Tables"]["Escalation"]["Update"];
export type EscalationRow = Database["public"]["Tables"]["Escalation"]["Row"];

export type EscalationAction = 'accept' | 'inProgress' | 'takeover';

export type EscalationEvent = 'accept' | 'inProgress' | 'takeover';

export interface EscalationUpdate {
  escalation: Escalation,
  report: Report,
  action: EscalationAction
}

export type LoggingEvent = "create" | 'accept' | 'takeover' | 'process' | 'complete' | 'emailNotification' | 'error'

export interface LogObject {
  id: string,
  reportId: string,
  assignedToUser: string | null,
  errorMessage?: string
}

export interface EscalationLog {
  id?: string,
  created_at?: string,
  created_by?: string,
  escalation_id: string,
  report: string,
  log_message: string
}

export type EventType = 'system' | 'comment';

export interface HistoryEvent {
  id: string,
  type: EventType,
  created_at: string,
  created_by: string,
  avatar_label?: string
  escalation_id?: string,
  color?: string,
  content?: string,
}
